import PastNotes from "modules/PastNotes/View";

import { ENotesEntity, EPipelineSlug } from "@type/api/management/types";

function PersonalInsideSalesPastNotes() {
  return (
    <PastNotes
      entityType={ENotesEntity.STAFF}
      pipelineSlug={EPipelineSlug.INSIDE_SALES}
    />
  );
}

export default PersonalInsideSalesPastNotes;
